import { useState, useCallback } from "react";

export interface AddressFlowFormData {
  name?: string;
  phoneNo?: string | number;
  type?: string;
  line1?: string;
  line2?: string;
  landmark?: string;
  city?: string;
  district?: string;
  state?: string;
  pincode?: string | number;
  countryCode?: string | number;
  coordinates?: { latitude: number; longitude: number } | null;
  id?: number;
  initialLocationData?: any;
  [key: string]: any;
}

export interface AddressFlowState {
  visible: boolean;
  step: "map" | "form";
  resolve: ((value: any) => void) | null;
  locationData: any;
  formData: AddressFlowFormData | null;
  editingAddressId: number | null;
  googleAddress?: any;
}

export function useAddressFlow() {
  const [flowState, setFlowState] = useState<AddressFlowState>({
    visible: false,
    step: "map",
    resolve: null,
    locationData: null,
    formData: null,
    editingAddressId: null,
  });

  const openAddressFlow = useCallback(
    (initialData: AddressFlowFormData = {}) => {
      const hasValidCoords =
        initialData?.coordinates &&
        initialData.coordinates.latitude !== 0 &&
        initialData.coordinates.longitude !== 0;

      const seedLocation = initialData?.initialLocationData || null;

      return new Promise<any>((resolve) => {
        setFlowState({
          visible: true,
          resolve,
          step: hasValidCoords ? "form" : "map",
          locationData: hasValidCoords
            ? {
                latLng: {
                  lat: initialData.coordinates!.latitude,
                  lng: initialData.coordinates!.longitude,
                },
                address: null,
                selectedLabel: "",
              }
            : seedLocation,
          formData: initialData || null,
          editingAddressId: initialData?.id || null,
        });
      });
    },
    [],
  );

  const closeFlow = useCallback(
    (result: any) => {
      if (flowState?.resolve) {
        flowState.resolve(result);
      }
      setFlowState((prev) => ({ ...prev, visible: false }));
    },
    [flowState],
  );

  return {
    flowState,
    setFlowState,
    openAddressFlow,
    closeFlow,
  };
}
